var _rect, _rect2, _path, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectorwrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 58,
    viewBox: "0 0 20 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.2919,
    height: 19.2919,
    rx: 9.64593,
    fill: "#EBEBF3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.602871,
    y: 0.602871,
    width: 17.7943,
    height: 17.7943,
    rx: 8.89713,
    stroke: "#2E3079",
    strokeWidth: 1.20574
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5349 5.85056L7.86658 11.321L6.36242 9.7139C6.08533 9.45265 5.64992 9.43681 5.33325 9.65848C5.0245 9.88806 4.93741 10.2918 5.12741 10.6164L6.90867 13.5139C7.08283 13.7831 7.38366 13.9493 7.72408 13.9493C8.04867 13.9493 8.35742 13.7831 8.53158 13.5139C8.81658 13.1418 14.2553 6.65806 14.2553 6.65806C14.9678 5.92973 14.1049 5.28848 13.5349 5.84265V5.85056Z",
    fill: "#2E3079"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.8418,
    y: 22.5073,
    width: 1.60766,
    height: 32.2775,
    rx: 0.803828,
    fill: "#2E3079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectorwrap);
export default __webpack_public_path__ + "static/media/Connector wrap.08cfef80b9f7e17bd674676799e5a11e.svg";
export { ForwardRef as ReactComponent };